export default __webpack_public_path__ + "static/media/red_1.16e9efb2.png";